import $ from 'jquery';
import templateContent from '../util/template_content';
import { initTooltips } from '@/js/modules/tooltips';
import { queryString, redirectWithParams } from '@/js/modules/query_params';
import { ajaxDelete } from '@/js/modules/ajax';
import { assignTasksStackingOrder } from '@/js/application/tasks';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_modal_defaults';
import '@/js/modules/jquery_datepicker_defaults';

let kanbanScrolled;
let creatingKanbanColumn;
let draggingKanbanWidth;
let draggingKanbanHeight;
let draggingKanbanColumn;
let isKanbanSorted;
let kanbanKind;

const placeCaretAtEnd = (el) => {
  el.focus();
  const range = document.createRange();
  range.selectNodeContents(el);
  range.collapse(false);
  const sel = window.getSelection();
  sel.removeAllRanges();
  sel.addRange(range);
};

const containerElement = ({ column }) =>
  document.querySelector(
    `.kanban-column-header__editable-container--clickable[data-column="${column}"]`
  );

const $clearElement = ({ column }) =>
  $(`.kanban-column-header__clear-header-editing[data-column="${column}"]`);

const nameContainer = ({ column }) =>
  document.querySelector(`.kanban-column-header__column-name[data-column="${column}"]`);

const addColumnIcon = () =>
  document.querySelector('.kanban-column-header__add-column-icon[data-column="new_column"]');

const rendersTotals = (column) => {
  if (column === 'new_column') {
    return false;
  }

  if (kanbanKind === 'task') {
    return true;
  }

  return kanbanKind === 'project' && column === 'new_requests';
};

const moreActionsDropdowns = () => [
  ...document.querySelectorAll('.dropdown-button__kanban-more-actions'),
];

const allowScrollingOnTablets = ($item) => {
  let scrolling = false;
  let startY;
  let startScrollTop;
  let $container;

  $item.on('touchstart', (event) => {
    scrolling = true;
    startY = event.touches[0].clientY;
    $container = $item.closest('.kanban-column__container');
    startScrollTop = $container.scrollTop();

    setTimeout(() => {
      scrolling = false;
    }, 750);
  });

  $item.on('touchend', () => {
    scrolling = false;
  });

  $item.on('touchmove', (event) => {
    if (scrolling) {
      const currentY = event.touches[0].clientY;
      const distanceY = startY - currentY;
      const scrollSensitivity = 1.5;
      const newScrollTop = startScrollTop + distanceY * scrollSensitivity;
      const maxScrollTop = $container.prop('scrollHeight') - $container.innerHeight();
      const finalScrollTop = Math.min(maxScrollTop, Math.max(0, newScrollTop));
      $container.scrollTop(finalScrollTop);
    }
  });
};

const initializeDraggable = ($item, isTouchDevice) => {
  const draggableOptions = {
    distance: 8,
    connectToSortable: '.kanban-column__container:not(.kanban-column__container--new-column)',
    helper: 'clone',
    revert: false,
    zIndex: 99,
    cancel:
      '.kanban-card__date-picker, .kanban-card__date-picker *, .kanban-card--learning-session-cta, .kanban-card--learning-session-cta *, .kanban-card--inline-form, .task-assignee__dropdown, .task-priority__dropdown, .kanban-card .dropdown-menu, .kanban-card .dropdown-menu *',
    start: (event, ui) => {
      if (creatingKanbanColumn) {
        return false;
      }
      isKanbanSorted = false;
      kanbanScrolled = Date.now();
      draggingKanbanColumn = $(event.target).closest('.kanban-column__container').data('column');
      draggingKanbanWidth = `${$(event.target).outerWidth()}px`;
      draggingKanbanHeight = `${$(event.target).outerHeight()}px`;
      $(ui.helper).addClass('kanban-card--dragging').css('width', draggingKanbanWidth);
      $(event.target).hide();
    },
    drag: () => {
      $('.kanban-card--placeholder').css('height', draggingKanbanHeight);
    },
    stop: (event, ui) => {
      const fromKanbanColumn = $(event.target).closest('.kanban-column').data('column');
      const toKanbanColumn = $(ui.helper).closest('.kanban-column').data('column');
      let $beforeObject = $(ui.helper).next().first();
      if ($beforeObject.hasClass('kanban-card--inline-form')) {
        $beforeObject = $beforeObject.next().first();
      }
      let $afterObject = $(ui.helper).prev().first();
      if ($afterObject.hasClass('kanban-card--inline-form')) {
        $afterObject = $afterObject.prev().first();
      }

      if (isKanbanSorted) {
        $(event.target).remove();
      } else {
        $(event.target).show();
      }

      if (kanbanKind === 'project') {
        updateKanbanPurchasingTooltip();
      }

      findNoObjectKanbanColumns();

      const $datePicker = $(ui.helper).find('.kanban-card__date-picker');
      $datePicker.removeClass('hasDatepicker');
      $datePicker.find('.ui-datepicker').remove();
      enableKanbanDatePicker($datePicker);
      const $objectDueDate = $(ui.helper).find('.kanban-card__due-date');
      if ($objectDueDate && $objectDueDate.attr('data-due-date')) {
        $objectDueDate
          .siblings('.kanban-card__date-picker')
          .datepicker('setDate', $objectDueDate.attr('data-due-date'));
      }
      initTooltips($(ui.helper).find('.tooltip'));
      assignTasksStackingOrder();
      $.post(
        `/kanban/${kanbanKind}/${$(ui.helper).data('id')}/xhr_update_kanban_column`,
        {
          from_kanban_column: fromKanbanColumn,
          to_kanban_column: toKanbanColumn,
          before_object_id: $beforeObject.data('id'),
          after_object_id: $afterObject.data('id'),
        },
        () => {
          // Update total tasks counter in column header.
          const fromTotal = nameContainer({ column: fromKanbanColumn });
          const toTotal = nameContainer({ column: toKanbanColumn });
          const { count: fromCount, oldName: fromOldName } = fromTotal.dataset;
          const { count: toCount, oldName: toOldName } = toTotal.dataset;

          const visibleName = (column, count, n, oldName) =>
            rendersTotals(column) ? `${oldName} (${parseInt(count) + n})` : oldName;

          if (fromKanbanColumn !== toKanbanColumn) {
            fromTotal.dataset.count = parseInt(fromCount) - 1;
            toTotal.dataset.count = parseInt(toCount) + 1;
            fromTotal.innerText = visibleName(fromKanbanColumn, fromCount, -1, fromOldName);
            toTotal.innerText = visibleName(toKanbanColumn, toCount, 1, toOldName);
          }

          if (kanbanKind === 'task') {
            // ensure inline form is always on top of To Do column
            [...document.querySelectorAll('.kanban-card--inline-form')].forEach((inlineForm) => {
              const { column: cardColumn } = inlineForm.dataset;
              const parent = document.querySelector(
                `.kanban-column__container[data-column="${cardColumn}"]`
              );
              parent.insertBefore(inlineForm, parent.firstChild);
            });
          }

          loadKanbanTasksIfNeeded(fromKanbanColumn);
        }
      );
    },
  };

  if (isTouchDevice) {
    draggableOptions.delay = 750;
  }

  $item.draggable(draggableOptions);
};

export const enableKanbanDraggable = ($item) => {
  let isTouchDevice = false;
  let hasTouchEvent = false;

  $item.on('touchstart', () => {
    if (!hasTouchEvent) {
      isTouchDevice = true;
      hasTouchEvent = true;
      initializeDraggable($item, isTouchDevice);
    }
  });

  if (!hasTouchEvent) {
    initializeDraggable($item, false);
  }

  allowScrollingOnTablets($item);
};

const enableKanbanSortable = ($item) => {
  $item.sortable({
    revert: false,
    placeholder: 'kanban-card--placeholder',
    zIndex: 99,
    cancel:
      '.kanban-card__date-picker, .kanban-card__date-picker *, .kanban-card--learning-session-cta, .kanban-card--learning-session-cta *, .kanban-card--inline-form, .task-assignee__dropdown, .task-priority__dropdown, .kanban-card .dropdown-menu, .kanban-card .dropdown-menu *',
    sort: (event, ui) => {
      const columnTop = $(event.target).position().top;
      const columnBottom = columnTop + $(event.target).outerHeight();
      const columnLeft = $(event.target).position().left;
      const currentTop = $(ui.item).position().top;
      const currentBottom = currentTop + $(ui.item).outerHeight();
      const currentLeft = $(ui.item).position().left;
      const currentRight = currentLeft + $(ui.item).outerWidth();
      const currentColumn = $(event.target).data('column');
      if (currentBottom >= columnTop && currentRight >= columnLeft) {
        $(event.target)
          .find('.kanban-card')
          .each((i, el) => {
            const elBottom = $(el).position().top + $(el).outerHeight() * 0.75;
            const elTop = $(el).position().top + $(el).outerHeight() * 0.25;
            if ((i === 0 || currentTop < columnTop + 100) && currentTop < elBottom) {
              if (Date.now() - kanbanScrolled > 1000) {
                $(event.target).scrollTop(
                  $(event.target).scrollTop() -
                    $(event.target).offset().top -
                    $(ui.item).outerHeight()
                );
                kanbanScrolled = Date.now();
              }
              $('.ui-sortable-placeholder', $(event.target)).insertBefore($(el));
              if (
                currentColumn !== draggingKanbanColumn ||
                (currentColumn === draggingKanbanColumn &&
                  $(el).data('id') !== $(ui.item).data('id'))
              ) {
                return false;
              }
            } else if (currentBottom > elTop) {
              if (currentBottom > columnBottom) {
                if (Date.now() - kanbanScrolled > 1000) {
                  $(event.target).scrollTop(
                    $(event.target).scrollTop() +
                      $(event.target).offset().top +
                      $(ui.item).outerHeight()
                  );
                  kanbanScrolled = Date.now();
                }
              }
              $('.ui-sortable-placeholder', $(event.target)).insertAfter($(el));
            } else if (currentTop < elBottom) {
              $('.ui-sortable-placeholder', $(event.target)).insertBefore($(el));
              return false;
            }
          });
      }
    },
    stop: (event, ui) => {
      isKanbanSorted = true;
      $(ui.item).removeClass('kanban-card--dragging').css('width', '100%').css('height', 'auto');
      enableKanbanDraggable($(ui.item));
    },
  });
};

export const initKanbanDragableAndSortable = () => {
  $('.kanban-column__container:not(.kanban-card--inline-form)').each((_i, el) => {
    enableKanbanSortable($(el));
  });

  $('.kanban-card:not(.kanban-card--inline-form)').each((_i, el) => {
    enableKanbanDraggable($(el));
  });
};

const loadKanbanObjects = ($col, offset = 0) => {
  const column = $col.data('column');
  const $columnContainer = $(`.kanban-column[data-column="${column}"]`);
  const params = () => {
    const { id: bodyId } = document.querySelector('body');
    const searchParams = new URLSearchParams(window.location.search);

    searchParams.set('column', column);
    searchParams.set('offset', offset);

    if (bodyId === 'projects-tasks') {
      const { content: projectId } = document.querySelector('[name=project-id]');
      searchParams.set('project_id', projectId);
    }

    return searchParams;
  };

  if ($columnContainer.attr('data-remaining-objects') === '0') {
    return;
  }

  $col.append('<div class="kanban-column__loading">Loading...</div>');

  $.get(`/kanban/${kanbanKind}/xhr_load_objects`, params().toString()).done((data) => {
    const { html = '' } = data;

    $col.find('.kanban-column__loading').remove();

    if (html.trim().length === 0) {
      // Add a flag in the DOM to avoid doing requests when we already
      // know there are no more objects to load for the current column.
      $columnContainer.attr('data-remaining-objects', 0);
      return;
    }

    $col.append(html);
    initKanbanDragableAndSortable();
    initKanbanDatePickers();
  });
};

export const findNoObjectKanbanColumns = () => {
  $('.kanban-column__container').each((_idx, column) => {
    if ($(column).find('.kanban-card:not(.kanban-card--inline-form)').length === 0) {
      $(column).addClass('kanban-column__container--no-objects');
    } else {
      $(column).removeClass('kanban-column__container--no-objects');
    }
  });
};

const updateKanbanPurchasingTooltip = () => {
  const hasPurchasingProjects =
    $('.kanban-column[data-column=in_purchasing]').find('.kanban-card').length > 0;
  const isHidePurchasingChecked = $('.dropdown-button__checkbox--hide-purchasing-kanban').is(
    ':checked'
  );

  if (hasPurchasingProjects && !isHidePurchasingChecked) {
    $('.dropdown-button__item--hide-purchasing-kanban')
      .addClass('df-tooltip')
      .find('.dropdown-button__item--checkbox')
      .addClass('dropdown-button__item--disable-hide-purchasing-kanban');
  } else {
    $('.dropdown-button__item--hide-purchasing-kanban')
      .removeClass('df-tooltip')
      .find('.dropdown-button__item--checkbox')
      .removeClass('dropdown-button__item--disable-hide-purchasing-kanban');
  }
};

export const enableKanbanDatePicker = ($item) => {
  $item.datepicker({
    onSelect: (dateText, inst) => {
      const datePicker = inst.input[0];
      const dateFormat = $('meta[name="date-format"]').attr('content');
      const objectId = $(datePicker).closest('.kanban-card').data('id');
      $.post(
        `/kanban/${kanbanKind}/${objectId}/xhr_assign_due_date`,
        {
          due_date: dateText,
          date_format: dateFormat,
        },
        (res) => {
          const $dueDate = $(datePicker).siblings('.kanban-card__due-date');
          const selectedDate = new Date(inst.selectedYear, inst.selectedMonth, inst.selectedDay);
          if (selectedDate < new Date()) {
            $dueDate.addClass('kanban-card__due-date--past-due');
          } else {
            $dueDate.removeClass('kanban-card__due-date--past-due');
          }
          $dueDate
            .removeClass('hide')
            .addClass('tooltip')
            .attr('data-due-date', dateText)
            .find('.kanban-card__due-date-text')
            .text(res.due_date);
          $(datePicker).addClass('hide');
          $(datePicker)
            .siblings('.kanban-card__add-due-date')
            .removeClass('tooltip')
            .addClass('hide');
          $item.find('.kanban-card__clear-due-date').removeClass('hide');
          initTooltips($dueDate);
        }
      );
    },
  });
};

export const initKanbanDatePickers = () => {
  $('.kanban-card__date-picker').each((_i, el) => {
    enableKanbanDatePicker($(el));
  });
};

const loadKanbanTasksIfNeeded = (columnName) => {
  // auto load more task when there're less than 5 cards in the column
  // so we can avoid empty column
  const $fromColumn = $(`.kanban-column__container[data-column="${columnName}"]`);
  const { length: offset } = $fromColumn.find('.kanban-card:not(.kanban-card--inline-form)');

  if (offset > 4) {
    return;
  }

  loadKanbanObjects($fromColumn, offset);
};

const initClickableHeader = () => {
  const columnContainer = ({ column }) =>
    document.querySelector(`.kanban-column__container[data-column="${column}"]`);

  let focusoutTimeoutHandler = null;
  const onClick = (e) => {
    if (focusoutTimeoutHandler) {
      clearTimeout(focusoutTimeoutHandler);
    }

    const $target = $(e.target);
    const column = $target.data('column');
    const nameContainerElement = nameContainer({ column });

    // Skip if already in edit mode to avoid resetting user input
    const isContainerElementOnFocus = $(nameContainerElement).is(':focus');
    if (isContainerElementOnFocus) {
      return;
    }

    if (rendersTotals(column)) {
      // Use stored oldName to restore clean name without count suffix.
      // This avoids regex issues with column names containing parentheses.
      nameContainerElement.innerText = nameContainerElement.dataset.oldName;
    }

    if (column === 'new_column') {
      if (nameContainerElement.dataset.oldName === 'Add New Column') {
        const container = document.querySelector(
          '.kanban-column-header__editable-container[data-column="new_column"]'
        );
        const addColumnIcon = document.querySelector(
          '.kanban-column-header__add-column-icon[data-column="new_column"]'
        );

        addColumnIcon.classList.add('hide');
        container.insertBefore(addColumnIcon, nameContainerElement);
        nameContainerElement.innerText = ' ';
        nameContainerElement.classList.add('kanban-column-header__column-name--new-column-focused');
        columnContainer({ column }).classList.remove('kanban-column__container--new-column');
      } else {
        $clearElement({ column }).toggle(true);
      }
    }

    nameContainerElement.contentEditable = true;
    nameContainerElement.spellcheck = true;
    nameContainerElement.focus();
    placeCaretAtEnd(nameContainerElement);
    $clearElement({ column }).toggle(true);
    containerElement({ column }).classList.add(
      'kanban-column-header__editable-container--clickable-focused'
    );
  };

  const onFocusout = (e) => {
    const { column } = e.target.dataset;
    const nameContainerElement = nameContainer({ column });
    const { innerText: newName } = nameContainerElement;
    const { count, oldName } = nameContainerElement.dataset;
    const visibleName = (name) => {
      // Count is stripped when editing starts, so user input is always the clean name.
      // No need to strip - just append the count.
      const clearName = name.trim();
      return rendersTotals(column) ? `${clearName} (${count})` : clearName;
    };

    nameContainerElement.contentEditable = false;
    nameContainerElement.spellcheck = false;

    containerElement({ column }).classList.remove(
      'kanban-column-header__editable-container--clickable-focused'
    );

    if (column === 'new_column' && newName === '') {
      if (oldName === 'Add New Column') {
        const addColumnIconElement = addColumnIcon();

        addColumnIconElement.classList.remove('hide');
        nameContainerElement.innerText = '';
        nameContainerElement.appendChild(addColumnIconElement);
        nameContainerElement.appendChild(document.createTextNode(` ${oldName}`));
        nameContainerElement.classList.remove(
          'kanban-column-header__column-name--new-column-focused'
        );
        columnContainer({ column }).classList.add('kanban-column__container--new-column');
      } else {
        nameContainerElement.innerText = oldName;
      }

      $clearElement({ column }).toggle(false);

      return;
    }
    creatingKanbanColumn = true;
    // Wait N ms to avoid submitting when clicking on the clear icon.
    focusoutTimeoutHandler = setTimeout(() => {
      const nameContainerElement = nameContainer({ column });
      const { contentEditable, innerText: newName } = nameContainerElement;
      const clearElement = $clearElement({ column });

      clearElement.toggle(false);

      if (clearElement.data('clicked') === true && contentEditable === 'true') {
        clearElement.attr('data-clicked', '');
        focusoutTimeoutHandler = null;
        creatingKanbanColumn = false;
        return;
      }

      // Return earlier to avoid making unnecessary requests.
      if (column !== 'new_column' && newName === oldName) {
        nameContainerElement.innerText = visibleName(newName);
        focusoutTimeoutHandler = null;
        creatingKanbanColumn = false;
        return;
      }

      if (newName.trim().length === 0) {
        nameContainerElement.innerText = visibleName(oldName);

        // Remove the column name selection if it stills renders as selected.
        if (window.getSelection) {
          window.getSelection().removeAllRanges();
        }
        focusoutTimeoutHandler = null;
        creatingKanbanColumn = false;
        return;
      }

      nameContainerElement.classList.remove('kanban-column-header__column-name--new-column');
      const $projectId = $('meta[name="project-id"]').attr('content');

      $.post(
        `/kanban/${kanbanKind}/xhr_update_column_header${
          $projectId ? `?project_id=${$projectId}` : ''
        }`,
        { column, name: newName },
        (columnHTML) => {
          focusoutTimeoutHandler = null;
          creatingKanbanColumn = false;
          if (column !== 'new_column') {
            nameContainerElement.dataset.oldName = newName;
            nameContainerElement.innerText = visibleName(newName);
            return;
          }

          const renderNewColumnAsEmpty = () =>
            [...document.querySelectorAll('.kanban-column__container')]
              .at(-2)
              .classList.add('kanban-column__container--no-objects');

          resetColumnNameHeader({ columnHTML });
          initKanbanDragableAndSortable();
          renderNewColumnAsEmpty();

          document
            .querySelector('.dropdown-button__action--delete-column')
            .classList.remove('dropdown-button__action--delete-column-disabled');
          const deleteColumnTextElement = document.querySelector(
            '.df-tooltip__text--delete-column'
          );
          if (deleteColumnTextElement) {
            deleteColumnTextElement.remove();
          }
        }
      ).fail(() => {
        focusoutTimeoutHandler = null;
        creatingKanbanColumn = false;
        nameContainerElement.innerText = visibleName(oldName);
      });
    }, 250);
  };

  const resetColumnNameHeader = ({ columnHTML }) => {
    const kanbanContainer = document.querySelector('.kanban-container');

    kanbanContainer.innerHTML += columnHTML;
    kanbanContainer.append(document.querySelector('.kanban-column[data-column="new_column"]'));

    // This is order dependent as the elements have been previously moved around.
    const addColumnIconElement = addColumnIcon();
    const newColumnNameContainer = nameContainer({ column: 'new_column' });

    addColumnIconElement.classList.remove('hide');
    newColumnNameContainer.innerText = '';
    newColumnNameContainer.appendChild(addColumnIconElement);
    newColumnNameContainer.appendChild(document.createTextNode(' Add New Column'));
    newColumnNameContainer.classList.remove(
      'kanban-column-header__column-name--new-column-focused'
    );
    newColumnNameContainer.classList.add('kanban-column-header__column-name--new-column');
    columnContainer({ column: 'new_column' }).classList.add('kanban-column__container--new-column');

    $('.kanban-column-header__column-name--clickable').on({
      click: onClick,
      focusout: onFocusout,
      keydown: onKeydown,
      keyup: onKeyup,
    });
  };

  const onKeydown = (e) => {
    // Prevent the content-editable element to become unusable after deleting all its content.
    setTimeout(() => {
      if (e.target.innerText.length === 0) {
        e.target.innerText = ' ';
      }
    }, 100);

    if (e.which === 13) {
      e.preventDefault();
    }
  };

  const onKeyup = (e) => {
    if (e.which === 13) {
      e.target.blur();
    } else {
      const {
        target: {
          dataset: { column },
          innerText,
        },
      } = e;

      $clearElement({ column }).toggle(innerText.length > 0);
    }
  };

  $('.kanban-column-header__column-name--clickable').on({
    click: onClick,
    focusout: onFocusout,
    keydown: onKeydown,
    keyup: onKeyup,
  });

  initClearHeaderButtons();
};

const initClearHeaderButtons = () =>
  document.querySelector('html').addEventListener('click', (e) => {
    const {
      target: {
        classList,
        dataset: { column },
      },
    } = e;

    if (!classList.contains('kanban-column-header__clear-header-editing')) {
      return;
    }

    const nameContainerElement = nameContainer({ column });

    // Setting this data attribute helps preventing this spreading to the onFocusout function.
    e.target.dataset.clicked = true;

    containerElement({ column }).classList.add(
      'kanban-column-header__editable-container--clickable-focused'
    );
    nameContainerElement.innerText = ' ';
    nameContainerElement.contentEditable = true;
    nameContainerElement.spellcheck = true;
    nameContainerElement.focus();
  });

const initMoreActionsButtons = () => {
  document.querySelector('html').addEventListener('click', (e) => {
    const {
      classList: clickedClassList,
      dataset: { column: clickedColumn },
    } = e.target;

    if (!clickedClassList.contains('kanban-column-header__more-actions')) {
      moreActionsDropdowns().forEach(({ classList }) => classList.add('hide'));
      return;
    }

    document
      .querySelector(`.dropdown-button__kanban-more-actions[data-column="${clickedColumn}"]`)
      .classList.toggle('hide');

    moreActionsDropdowns()
      .filter(({ dataset: { column } }) => column !== clickedColumn)
      .forEach(({ classList }) => classList.add('hide'));
  });

  // Render "More Actions" tooltip message on button mouse over.
  document.querySelector('html').addEventListener('mouseover', ({ target }) => {
    if (target.classList.contains('kanban-column-header__more-actions')) {
      document
        .querySelector(
          `.df-tooltip__text--kanban-more-actions[data-column="${target.dataset.column}"]`
        )
        .classList.remove('df-tooltip__text--hidden');
    }
  });

  // Hide "More Actions" tooltip message on button mouse out.
  document.querySelector('html').addEventListener('mouseout', ({ target }) => {
    if (target.classList.contains('kanban-column-header__more-actions')) {
      document
        .querySelector(
          `.df-tooltip__text--kanban-more-actions[data-column="${target.dataset.column}"]`
        )
        .classList.add('df-tooltip__text--hidden');
    }
  });

  // Show "can't delete column" tooltip message on anchor mouse over.
  document.querySelector('html').addEventListener('mouseover', ({ target }) => {
    if (target.classList.contains('dropdown-button__action--delete-column')) {
      const tooltip = document.querySelector(
        `.df-tooltip__text--delete-column[data-column="${target.dataset.column}"]`
      );

      if (tooltip) {
        tooltip.classList.remove('df-tooltip__text--hidden');
      }
    }
  });

  // Hide "can't delete column" tooltip message on anchor mouse out.
  document.querySelector('html').addEventListener('mouseout', ({ target }) => {
    if (target.classList.contains('dropdown-button__action--delete-column')) {
      const tooltip = document.querySelector(
        `.df-tooltip__text--delete-column[data-column="${target.dataset.column}"]`
      );

      if (tooltip) {
        tooltip.classList.add('df-tooltip__text--hidden');
      }
    }
  });
};

const initDropdownEditButtons = () =>
  document.querySelector('html').addEventListener('click', (e) => {
    const {
      target: {
        classList,
        dataset: { column },
      },
    } = e;

    if (!classList.contains('dropdown-button__action--edit-column')) {
      return;
    }

    e.preventDefault();
    // Prevent the event from bubbling up to parent handlers
    e.stopPropagation();

    const columnHeaderSelector = `.kanban-column-header__column-name--clickable[data-column="${column}"]`;
    const clearElement = $clearElement({ column });

    // Mark as clicked to signal the column header's click handler
    clearElement.data('clicked', true);
    // Delegate to existing column header click handler instead of duplicating edit logic
    document.querySelector(columnHeaderSelector).click();
  });

const initDropdownDeleteColumnButtons = () =>
  document.querySelector('html').addEventListener('click', (e) => {
    const {
      target: {
        classList,
        dataset: { column },
      },
    } = e;

    if (
      !classList.contains('dropdown-button__action--delete-column') ||
      classList.contains('dropdown-button__action--delete-column-disabled')
    ) {
      return;
    }

    e.preventDefault();

    const $kanbanColumn = $(`.kanban-column[data-column="${column}"]`);
    const $columnName = $kanbanColumn.find('.kanban-column-header__column-name');
    const totalCount = parseInt($columnName.attr('data-count'));
    const completedCount = $kanbanColumn.find('.checkbox--task-status:checked').length;
    const tasks = (count, kind) => `${count} ${kind}task${count === 1 ? '' : 's'}`;

    const modal = templateContent(document.getElementById('kanban-delete-column-template'));
    modal.querySelector('[name="column"]').value = column;
    modal.querySelector('[data-kanban-delete-column-name]').textContent =
      $columnName.attr('data-old-name');
    modal.querySelector('[data-kanban-delete-column-completed]').textContent = tasks(
      completedCount,
      'completed '
    );
    modal.querySelector('[data-kanban-delete-column-incomplete]').textContent = tasks(
      totalCount - completedCount,
      'incomplete '
    );
    modal.querySelectorAll('[data-kanban-delete-column-count]').forEach((count) => {
      count.textContent = tasks(totalCount, '');
    });
    modal.querySelector('[data-kanban-delete-column-details]').hidden = totalCount === 0;
    document.body.append(modal);
  });

const initKanbanColumnsSortable = () => {
  $('.kanban-container--sortable').each((_i, el) => {
    enableKanbanColumnsSortable($(el));
  });
};

const enableKanbanColumnsSortable = ($item) => {
  $item.sortable({
    items: '.kanban-column--sortable',
    handle: '.kanban-column-header',
    cancel:
      '.dropdown-button__kanban-more-actions, .kanban-column-header__editable-container--clickable-focused',
    revert: false,
    zIndex: 99,
    distance: 8,
    placeholder: 'kanban-column--placeholder',
    tolerance: 'pointer',
    start: (event, ui) => {
      ui.item.addClass('kanban-column--drag-start');
    },
    stop: (event, ui) => {
      ui.item.removeClass('kanban-column--drag-start');

      const columnPositions = {};
      const $columns = $('.kanban-column--sortable');
      $columns.each((index, column) => {
        const columnId = $(column).find('.kanban-column-header__column-name').data('column');
        columnPositions[columnId] = { position: index };
      });

      $.ajax({
        url: '/kanban/task/xhr_reorder_columns',
        type: 'patch',
        data: { positions: columnPositions },
      });
    },
  });
};

onPageLoad(() => {
  kanbanScrolled = 0;
  kanbanKind = undefined;

  creatingKanbanColumn = false;

  $(function () {
    const $body = $('body');

    if ($body.is('#designer-projects')) {
      kanbanKind = 'project';
    } else if ($body.is('#tasks, #projects-tasks')) {
      kanbanKind = 'task';
    }

    if (kanbanKind === 'project') {
      updateKanbanPurchasingTooltip();
      initKanbanDragableAndSortable();
      initKanbanDatePickers();
      initClickableHeader();

      $(document).on('change', '.dropdown-button__checkbox--hide-purchasing-kanban', (e) => {
        $('.kanban-column[data-column=in_purchasing]').toggleClass(
          'hide',
          $(e.target).prop('checked')
        );
        updateKanbanPurchasingTooltip();
        $.post('/users/xhr_set_preference', {
          key: 'hide_purchasing_kanban',
          value: $(e.target).prop('checked'),
        });
      });

      $(document).on('click', '.kanban-card', (e) => {
        const isBookmarkletCta = () =>
          $(e.target).hasClass('kanban-card--learning-session-cta') ||
          $(e.target).closest('.kanban-card').hasClass('kanban-card--learning-session-cta');

        const isCalendarLink = () =>
          $(e.target).hasClass('kanban-card__add-due-date') ||
          $(e.target).parent().hasClass('kanban-card__add-due-date') ||
          $(e.target).hasClass('kanban-card__due-date-icon') ||
          $(e.target).parent().hasClass('kanban-card__due-date-icon') ||
          $(e.target).hasClass('kanban-card__due-date') ||
          $(e.target).parent().hasClass('kanban-card__due-date') ||
          $(e.target).parents('.ui-datepicker').length > 0 ||
          $(e.target).hasClass('kanban-card__clear-due-date');

        const isCardMenu = () => $(e.target).closest('.dropdown-menu').length > 0;

        if (isCardMenu()) {
          // Let menu links handle their own clicks.
          return;
        } else if (isCalendarLink()) {
          return false;
        } else if (!isBookmarkletCta()) {
          e.preventDefault();
          const card =
            $(e.target).className === 'kanban-card'
              ? $(e.target).data('id')
              : $(e.target).closest('.kanban-card');
          const projectId = card.data('id');
          const gotoUrl = `/projects/${projectId}`;
          window.location.href = gotoUrl;
        }
      });

      $(document).on(
        'click',
        '.kanban-card--learning-session-cta .learning-session-cta__button',
        (e) => {
          window.open($(e.target).attr('href'), '_blank');
        }
      );

      $(document).on('click', '.dropdown-button__item--reset-kanban-column-headers', () => {
        $.post(`/kanban/${kanbanKind}/xhr_reset_column_headers`, {}, (columnHeaders) => {
          for (const column in columnHeaders) {
            const nameContainerElement = nameContainer({ column });
            const name = columnHeaders[column];

            nameContainerElement.innerText = rendersTotals(column)
              ? `${name} (${nameContainerElement.dataset.count})`
              : name;
            nameContainerElement.dataset.oldName = name;
          }
          $('.dropdown-button__item--reset-kanban-column-headers').addClass('hide');
        });
      });
    }

    if (kanbanKind === 'task') {
      initKanbanDragableAndSortable();
      initKanbanDatePickers();
      initClickableHeader();
      initKanbanColumnsSortable();
      initMoreActionsButtons();
      initDropdownEditButtons();
      initDropdownDeleteColumnButtons();
    }

    findNoObjectKanbanColumns();

    $(document).on('click', '.view-mode', (e) => {
      e.preventDefault();

      const params = Object.assign(queryString(), { view_mode: e.target.dataset.mode });
      redirectWithParams(params);
    });

    $('.kanban-column__container').on('scroll', (e) => {
      const $target = $(e.target);
      const column = $target.data('column');
      const $columnContainer = $(`.kanban-column[data-column="${column}"]`);
      const offset = $columnContainer.find('.kanban-card:not(.kanban-card--inline-form)').length;

      if (
        $target.scrollTop() + $target.innerHeight() >= $target[0].scrollHeight - 200 &&
        $target.find('.kanban-column__loading').length === 0
      ) {
        loadKanbanObjects($target, offset);
      }
    });

    // The object has no due date. The action is to set one.
    $(document).on('click', '.kanban-card__add-due-date', (e) => {
      e.preventDefault();

      // Hide all currently open date pickers
      $('.kanban-card__date-picker').addClass('hide');

      const $target = $(e.target);

      const $el = $target.hasClass('kanban-card__add-due-date')
        ? $target
        : $target.closest('.kanban-card__add-due-date');

      $el
        .siblings('.kanban-card__date-picker')
        .toggleClass('hide')
        .css('top', '24px')
        .css('left', 'auto')
        .css('right', '-8px');
    });

    // The object has a due date. The action is to update it.
    $(document).on('click', '.kanban-card__due-date', (e) => {
      e.preventDefault();

      // Hide all currently open date pickers
      $('.kanban-card__date-picker').addClass('hide');

      const $target = $(e.target);

      const $el = $target.hasClass('kanban-card__due-date')
        ? $target
        : $target.closest('.kanban-card__due-date');

      $el
        .siblings('.kanban-card__date-picker')
        .toggleClass('hide')
        .datepicker('setDate', $el.attr('data-due-date'))
        .css('top', '24px')
        .css('left', 'auto')
        .css('right', '8px');
    });

    $(document).on('click', '.kanban-card__clear-due-date', (e) => {
      const objectId = $(e.target).closest('.kanban-card').data('id');
      ajaxDelete(`/kanban/${kanbanKind}/${objectId}/xhr_clear_due_date`, {}, () => {
        $(e.target).addClass('hide');
        const $datePicker = $(e.target).closest('.kanban-card__date-picker');
        $datePicker.addClass('hide').datepicker('setDate', null);
        const $projectDueDate = $datePicker.siblings('.kanban-card__due-date');
        $projectDueDate.addClass('hide').removeClass('tooltip').attr('data-due-date', null);
        const $addDueDate = $projectDueDate.siblings('.kanban-card__add-due-date');
        $addDueDate.addClass('tooltip').removeClass('hide');
        initTooltips($addDueDate);
      });
    });

    $(document).on('mouseover', '.kanban-column--sortable .kanban-column-header', (e) => {
      $(e.target).closest('.kanban-column--sortable').addClass('kanban-column--hover');
    });
    $(document).on('mouseout', '.kanban-column--sortable .kanban-column-header', (e) => {
      $(e.target).closest('.kanban-column--sortable').removeClass('kanban-column--hover');
    });
    // disable copy/paste on column title field
    $(document).on('paste', '.kanban-column-header__column-name--clickable', function (e) {
      e.preventDefault();
    });
  });
});
